import axios from 'axios';

const API_ENDPOINT = process.env.REACT_APP_BASE_URL;

export const endpoint = axios.create({
  baseURL: API_ENDPOINT,
});
